import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerUnitComponent } from './banner-unit-v1/banner-unit-v1.component';
import { BannerUnitCarouselComponent } from './banner-unit-carousel-v1/banner-unit-carousel-v1.component';
import { LazyDirective } from './lazy/lazy.directive';

@NgModule({
  declarations: [
    BannerUnitComponent,
    LazyDirective,
    BannerUnitCarouselComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    BannerUnitComponent,
    BannerUnitCarouselComponent
  ],
  providers: [
    BannerUnitComponent,
    BannerUnitCarouselComponent
  ]
})
export class BannerUnitModule { }
